export default __webpack_public_path__ + "static/why-ml-10-a70806a16b73468f15d05ac866863df1.webp";